import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useIntl } from "react-intl"
import { ConfigProvider, FormProps } from "antd"
import meetingStore from 'store/meetingStore'
import { MeetingModel } from 'api/meeting-model'
import { useSearchParams } from "react-router"
import { getCheckinQuery } from "api/vote"
import { ymdhms } from "utils/date-format"
import { UploadOutlined } from "@ant-design/icons"
import { utils, writeFile } from "xlsx"

dayjs.extend(utc);
dayjs.extend(timezone);

export default function SignIn() {

  const intl = useIntl()

  const { meetingInfo } = meetingStore();

  const [locationSearch] = useSearchParams();
  const meetingIdInQuery = locationSearch.get('meeting_id') ?? meetingInfo?.meeting_id;

  const [currentMeeting, setCurrentMeeting] = useState<MeetingModel | null>(meetingInfo)

  const [searchParams, setSearchParams] =
    useState({
      meeting_id: meetingInfo?.meeting_id ?? '',
    })

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [loadingExport, setLoadingExport] = useState(false);

  useEffect(() => {
    getCheckinQuery(currentMeeting?.meeting_id!).then(res => {
      if (res.code == 0) {
        if (res.data != null && res.data.meeting_checkin != null) {
          const tempData = JSON.parse(res.data.meeting_checkin);

          const tempUserData:any[] = JSON.parse(res.data.meeting_user);

          let tempCheckInUser: any[] = [];

          //构建签到数据
          tempData.forEach((element: any) => {
            element.checkins.forEach((element1: any) => {

              const user = tempUserData.find(a => a.id == element1.account_id);
              tempCheckInUser.push(
                {
                  description: element.description,
                  duration: element.duration,
                  create_time: element.create_time,
                  account_id: element1.account_id,
                  checkin_time: element1.checkin_time,
                  account: user.account,
                  name: user.fullname,
                  company: user.company,
                }
              );

            });
          });

          setData(tempCheckInUser);
        }
        else{
          setData([]);
        }
      }
      setLoading(false);
    })
  }, [currentMeeting])


  const columns = useMemo<TableProps<any>['columns']>(() => {
    return [
      {
        title: intl.formatMessage({ id: "sign.in.page.username" }),
        dataIndex: 'account'
      },
      {
        title: intl.formatMessage({ id: "sign.in.page.name" }),
        dataIndex: 'name'
      },
      {
        title: intl.formatMessage({ id: "sign.in.page.class" }),
        dataIndex: 'company'
      },
      {
        title: intl.formatMessage({ id: "sign.in.page.signinTime" }),
        dataIndex: 'checkin_time',
        render(value: string): string {
          return value ? dayjs.utc(value).tz(meetingInfo?.time_zone).format(ymdhms) : '-'
        }        
      },
      {
        title: intl.formatMessage({ id: "sign.in.page.signinInstructions" }),
        dataIndex: 'description'
      },  
      {
        title: intl.formatMessage({ id: "sign.in.page.signinDuration" }),
        dataIndex: 'duration'
      },                         
      {
        title: intl.formatMessage({ id: "sign.in.page.createdTime" }),
        dataIndex: 'create_time',
        render(value: string): string {
          return value ? dayjs.utc(value).tz(meetingInfo?.time_zone).format(ymdhms) : '-'
        }
      }  
    ];
  }, [currentMeeting, intl.locale])


  const meetingLoadFinishHandler = async () => {
    if (meetingIdInQuery != null) {
    }
  }

  const meetingChangeHandler: MeetingSelectProps['onMeetChange'] = async (
    value: string,
    option
  ) => {
    if (option != undefined) {
      setCurrentMeeting(option!.meeting)
      setTimeout(async () => {
      })
    }
  }

  const searchChangeHandler: FormProps<any>['onValuesChange'] =
    (changedValues, allValues) => {
      setSearchParams({ ...searchParams, ...allValues })
    }

  const excelColumns = 7;

  //  生成excel
  const downloadExcelAll = async () => {
    setLoadingExport(true);

    let tempExcelData: any[] = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      if (element != null) {
        tempExcelData.push({
          [intl.formatMessage({ id: "sign.in.page.username" })]: element.account,
          [intl.formatMessage({ id: "sign.in.page.name" })]: element.name,
          [intl.formatMessage({ id: "sign.in.page.class" })]: element.company,
          [intl.formatMessage({ id: "sign.in.page.signinTime" })]: element.checkin_time ? dayjs.utc(element.checkin_time).tz(meetingInfo?.time_zone).format(ymdhms) : '-',
          [intl.formatMessage({ id: "sign.in.page.signinInstructions" })]: element.description,
          [intl.formatMessage({ id: "sign.in.page.signinDuration" })]: element.duration,
          [intl.formatMessage({ id: "sign.in.page.createdTime" })]: element.create_time ? dayjs.utc(element.create_time).tz(meetingInfo?.time_zone).format(ymdhms) : '-',
        })
      }
    }

    const workbook = utils.book_new();

    const worksheet = utils.json_to_sheet(tempExcelData);

    if (!worksheet["!cols"]) worksheet["!cols"] = [];

    for (let index = 0; index < Math.max(excelColumns, data.length); index++) {
      if (!worksheet["!cols"][index]) {
        worksheet["!cols"][index] = { wch: 8 };
        worksheet["!cols"][index].wpx = 180;
      }
    }

    utils.book_append_sheet(
      workbook,
      worksheet,
      'signIn',
    );

    const date = dayjs().format('YYYYMMDD_HHmmss');

    const res = writeFile(workbook, `sing-in-${date}.xlsx`);

    setLoadingExport(false);
  }    

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Form: {
              itemMarginBottom: 15
            },
          },
        }}
      >
        <Form
          onValuesChange={searchChangeHandler}
        >
          <Flex className="tw-pt-4 tw-px-6 tw-bg-[#FBFCFF] tw-rounded-t-lg" justify="space-between">
            <Flex justify="space-around" gap="small">
              <Form.Item
                label={intl.formatMessage({ id: "table.meeting" })}
                name="meeting_id"
                initialValue={meetingIdInQuery}
              >
                <MeetingSelect
                  allowClear={false}
                  autoSelect={!meetingIdInQuery}
                  onLoadFinish={meetingLoadFinishHandler}
                  onMeetChange={meetingChangeHandler}
                />
              </Form.Item>
            </Flex>
            <Flex gap="small">
              <Button
                icon={<UploadOutlined />}
                iconPosition="end"
                loading={loadingExport}
                className="linearGradientBackgroundStyle"
                onClick={downloadExcelAll}
              >
                {intl.formatMessage({ id: "common.export" })}
              </Button>
            </Flex>
          </Flex>
        </Form>
      </ConfigProvider>
    <Table
      rowKey="account_id"
      columns={columns}
      dataSource={data}
      bordered={false}
      loading={loading}
      pagination={false}
      scroll={{x:"max-content"}}
    />
    <div>&nbsp;</div>
    </>
  )
}
